import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapVoid } from '../normalize'

export type SaveCommentParams = {
  dataCollectionStatementId: string
  findingId: string
  userRole: string
  message: string
}

export const saveComment = async (params: SaveCommentParams): Promise<void> => {
  const response = await apiClient.post(endpoints.findingComments, params)
  return unwrapVoid(response)
}

export default saveComment
